import ArCustomerCategory from './impl/ArCustomerCategory'
export default {
  arCustomer: ArCustomerCategory
}
